import React, { FC } from 'react';

import { BUTTON_TYPES, EvConfirm } from '@evinced-private/ui-common';

import { SITE_SCANNER_APP_ID } from 'src/consts/dom-consts';
import { IUrlSeedDisplay } from 'src/interfaces/UrlSeedDisplay';

import { SEEDS_LIST_LABELS } from './SeedsList.labels';

interface SeedsTableSelectionActionsProps {
	seeds: IUrlSeedDisplay[];
	selectedSeeds: IUrlSeedDisplay[];
	updatePropertySeeds: (seeds: IUrlSeedDisplay[], closeModal: () => void) => void;
}

export const SeedsTableSelectionActions: FC<SeedsTableSelectionActionsProps> = ({
	seeds,
	selectedSeeds,
	updatePropertySeeds
}) => {
	const selectedLength = selectedSeeds.length;
	const isSelectedEmpty = selectedLength === 0;
	const isSelectedMultiple = selectedLength > 1;
	const isAllSelected = selectedLength === seeds.length;
	const urlText = `${isSelectedMultiple || (isAllSelected && isSelectedMultiple) ? 'URLs' : 'URL'}`;
	const selectedCountText = isSelectedMultiple ? selectedLength : '';
	const countLabel = isAllSelected && isSelectedMultiple ? 'All' : selectedCountText;
	const buttonTitle = ['Remove', countLabel, urlText].filter(Boolean).join(' ');

	return (
		<div className="property-urls-table-actions">
			<EvConfirm
				appElement={SITE_SCANNER_APP_ID}
				title={SEEDS_LIST_LABELS.CONFIRM_REMOVING_URLS}
				promptMessage={`Are you sure you want to ${buttonTitle.toLocaleLowerCase()}?`}
				triggerButtonProps={{
					type: BUTTON_TYPES.GHOST,
					// EvButton dropped `disabledReason`. The tooltip text is `title`,
					// written to `data-tooltip-content` when `customTooltip` renders.
					title: isSelectedEmpty ? SEEDS_LIST_LABELS.DISABLED_REASON : buttonTitle,
					disabled: isSelectedEmpty,
					customTooltip: isSelectedEmpty ? { renderTooltip: true } : null,
					children: buttonTitle
				}}
				onConfirm={(closeModal) => {
					const newSeeds = seeds.filter((seed) => {
						return !selectedSeeds.find((selected) => selected.url === seed.url);
					});
					updatePropertySeeds(newSeeds, closeModal);
				}}
			/>
			<EvConfirm
				appElement={SITE_SCANNER_APP_ID}
				title={SEEDS_LIST_LABELS.CONFIRM_REMOVING_ALL_URLS}
				promptMessage={`Are you sure you want to clear all URLs? (${seeds.length})`}
				triggerButtonProps={{
					type: BUTTON_TYPES.SECONDARY,
					title: SEEDS_LIST_LABELS.CLEAR_LIST,
					children: SEEDS_LIST_LABELS.CLEAR_LIST
				}}
				onConfirm={(closeModal) => {
					updatePropertySeeds([], closeModal);
				}}
			/>
		</div>
	);
};
